import React, { Component } from "react";
import history from "./../history";
import "../Center.css";
const Web3 = require("web3");

let web3;

export default class Start extends Component {
  state = {
    metaEnabled: "",
    metaInstalled: "",
    onRopsten: ""
  };

  async checkOnRopsten() {
    let onRopsten;
    if (window.ethereum) {
      web3 = new Web3(window.ethereum);
      try {
        let netId = await web3.eth.net.getId();
        switch (netId) {
          case 1:
            console.log("This is mainnet");
            break;
          case 2:
            console.log("This is the deprecated Morden test network.");
            break;
          case 3:
            console.log("This is the ropsten test network.");
            onRopsten = true;
            break;
          case 4:
            console.log("This is the Rinkeby test network.");
            break;
          case 42:
            console.log("This is the Kovan test network.");
            break;
          default:
            console.log("This is an unknown network.");
        }
      } catch (e) {
        console.log("Please enable metmask");
      }
    } else {
      // alert("You have to install MetaMask!");
    }
    this.setState({
      onRopsten
    });
    return onRopsten;
  }

  async getWeb3() {
    let metaEnabled;
    if (window.ethereum) {
      web3 = new Web3(window.ethereum);
      try {
        metaEnabled = (await window.ethereum.enable()) !== undefined;
      } catch (e) {
        console.log("Please enable metmask");
      }
    } else {
      // alert("You have to install MetaMask!");
    }
    console.log("Meta Enabled", metaEnabled);
    this.setState({
      metaEnabled
    });
    return metaEnabled;
  }

  async checkWeb3() {
    try {
      let web3 = new Web3(window.ethereum);
      let accounts = await web3.eth.getAccounts();
      console.log("Acccounts", accounts);
      return accounts.length > 0;
    } catch (e) {
      return false;
    }
  }

  checkEthereum() {
    return !(window.ethereum === undefined);
  }

  async componentDidMount() {
    let metaInstalled = this.checkEthereum();
    console.log("Meta installed", metaInstalled);
    let metaEnabled = await this.checkWeb3();
    console.log("Meta Enabled", metaEnabled);
    let onRopsten = await this.checkOnRopsten();
    console.log("On Ropsten", metaEnabled);
    this.setState({
      metaEnabled,
      metaInstalled,
      onRopsten
    });
  }

  render() {
    const requestMeta = () => {
      if (!this.state.metaEnabled && this.state.metaInstalled) {
        return (
          <div>
            <p style={{ color: "red" }}>
              Please connect your wallet, and select the
              <b style={{ color: "red" }}> Ropsten </b>
              network
            </p>
          </div>
        );
      } else {
        return (
          <div>
            <p></p>
          </div>
        );
      }
    };

    const selectRopsten = () => {
      if (this.state.metaInstalled && !this.state.onRopsten) {
        return (
          <div>
            <p style={{ color: "red" }}>
              Wrong network. Please select the Ropsten network.
            </p>
          </div>
        );
      } else {
        return (
          <div>
            <p></p>
          </div>
        );
      }
    };

    const installMeta = () => {
      if (!this.state.metaInstalled) {
        return (
          <div>
            <p style={{ color: "red" }}>
              Please install{" "}
              <a
                style={{ color: "red", textDecoration: "underline" }}
                href="https://metamask.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                MetaMask
              </a>{" "}
              or any wallet supporting
              <br />
              <b style={{ color: "red" }}>Ropsten</b> testnet
            </p>
          </div>
        );
      } else {
        return (
          <div>
            <p></p>
          </div>
        );
      }
    };

    const connectButton = () => {
      if (
        !this.state.metaInstalled ||
        (this.state.metaInstalled && !this.state.metaEnabled)
      ) {
        return (
          <div className="col-md-4">
            <button
              type="button"
              className="primary-btn btn-block"
              disabled={!this.state.metaInstalled}
              onClick={() => this.getWeb3()}
            >
              Connect Wallet
            </button>
          </div>
        );
      }
    };

    const startSetupButton = () => {
      if (this.state.metaEnabled) {
        return (
          <div className="col-md-4 not-first">
            <button
              type="button"
              className="primary-btn btn-block"
              disabled={!this.state.onRopsten}
              onClick={() =>
                history.push(`${process.env.PUBLIC_URL}/TestnetEth`)
              }
            >
              Start Setup
            </button>
          </div>
        );
      }
    };

    return (
      <div className="Start lander">
        <div className="lander">
          <img
            className="photo"
            src={process.env.PUBLIC_URL + "/ba-dap-prove-logo.png"}
            alt="baDAPProve"
            style={{ marginBottom: "20px" }}
          />
          <h1>This is a demo of the baDAPProve exploit</h1>
          <p>
            The exploit shows how a smart contract can maliciously obtain
            unlimited access to a user's funds, without their knowledge.
            <br />
            <br />
            <b>
              This demo runs on testnet currency, so you can experience the
              exploit without taking any risks.
            </b>
            <br />
            <br />
            The DApp was tested with{" "}
            <u>
              <a
                href="https://metamask.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Metamask
              </a>
            </u>{" "}
            and{" "}
            <u>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.opera.com/he/crypto"
              >
                Opera mobile wallet
              </a>
            </u>
            <br />
            <br />
            First, we will set you up with testnet ETH and ERC-20 tokens.
          </p>
          <div className="row bottom"></div>
          {connectButton()}
          {startSetupButton()}
          <br />
          {selectRopsten()}
          {requestMeta()}
          {installMeta()}
        </div>
      </div>
    );
  }
}
